export default {
    appTitle: "Kuusakoski Weee",
    address: {
        address: "Osoite",
        billingAddress: "Laskutusosoite",
        city: "Kaupunki",
        company: "Yritys",
        country: "Maa",
        deliveryAddress: "Toimitusosoite",
        retrievalAddress: "Nouto-osoite",
        streetAddress: "Katuosoite",
        zipCode: "Postinumero",
    },
    common: {
        allow: "Salli",
        send: "Lähetä",
        sendOrder: "Lähetä tilaus",
        bool: {
            true: "Kyllä",
            false: "Ei"
        }
    },
    weeeCustomerEmail: {
        errorMessage: "Tapahtui odottamaton virhe, ota yhteyttä asiakaspalveluun 0800 30880, asiakaspalvelu@kuusakoski.com",
        loadingMessage: "Tietoja haetaan.. Jos tämä viesti jää näkyviin pitkätksi aikaa, ota yhteyttä asiakaspalveluun 0800 30880, asiakaspalvelu@kuusakoski.com",
        subscribeMessage: "Noudon muistutusviestit peruttu. Sallitaanko ne uudelleen?",
        unnecessaryReminderMessage: "Oliko muistutus on mielestäsi aiheeton?",
        unnecessaryReminderLabel: "Kerro meille, miksi muistutus on mielestäsi aiheeton?",
        unnecessaryReminderLink: "Tee ilmoitus",
        unsubscribeConfirmMessage: "Haluatko varmasti perua tilaukseltasi noudon muistutusviestit?",
    },
    weeeCustomerOrder: {
        aalandZipCodeError: "Turvaroskis hinnoittelu on voimassa manner-Suomessa. Jos haluat tilata Ahvenanmaalle, ota yhteys turvaroskis@kuusakoski.com",
        ask: "KYSY!",
        billingAddressIsDifferentFromShippingAddress: "Laskutusosoite on eri kuin toimitusosoite",
        contactRequestNotice: "Kerro lisätiedoissa noudettavan materiaalin tyyppi, määräarvio ja sijainti. Laskutustietoja ei tarvitse täyttää.",
        copyright: "© 2018 Kuusakoski",
        customerservice: "Valtakunnallinen asiakaspalvelu 0800 30880",
        declaration: "Vakuutan, että antamani tiedot edustamastani yrityksestä ovat oikein ja minulla on oikeus toimia yrityksen edustajana. <a href='https://www.kuusakoski.com/fi/finland/yritys/lakiasiat/kuusakosken-verkkosivujen-tietosuojaseloste-ja-evastekaytannot/' target='_blank'>Miten henkilötietojani käytetään?</a>",
        expressDelivery: "Haluan tilata maksullisen pikatoimituksen lisähintaan {price} €/keräysväline/suunta (vain Helsinki, Espoo, Vantaa, Kauniainen). Pikatoimituksissa toimitamme astiat tilauspäivää seuraavana työpäivänä, jos tilaus on tehty ennen klo 12.",
        expressDeliveryTooltip: "Pikakuljetukset, jotka on tilattu klo 12 jälkeen, pyritään myös toimittamaan tilausta seuraavana työpäivänä, mutta ne toimitetaan viimeistään toisena työpäivänä tilauspäivästä laskien.",
        hardToReachPlace: "Kohde on vaikeakulkuisessa paikassa (täsmennä lisätiedot-kentässä, esim. portaita, pieni hissi)",
        extraService: {
            destructionCertificate: {
                inputLabel: "Haluan lisäpalveluna sarjanumerokohtaisen<br>tuhoustodistuksen",
                inputTooltip: "Tietoa sisältävistä laitteista kirjoitetaan sarjanumerokohtainen tuhoustodistus (puhelimet, kiintolevyt, tietokoneet, tulostimet). Sarjanumeroiden tulee olla koneellisesti tai silmin luettavissa, laitetta purkamatta.",
                summaryDisplayName: "Pieni kierrätysastia + Laaja raportti",
                summaryInputLabel: "Tuhoustodistus",
            },
            largeContainerBin: {
                inputTooltip: "Kun teet tämän valinnan, toimitamme palvelun normaalikokoisen astian sijaan 660 litran tietosuoja-astialla.",
                inputLabel: "Vaihda 660L astiaksi",
                summaryInputLabel: "Vaihdettu 660L astiaksi",
            },
            largeContainerCage: {
                inputTooltip: "Kun teet tämän valinnan, toimitamme palvelun tietoturvarullakon sijaan 240 litran tietosuoja-astialla. Haluatko rullakon lisäksi myös tietosuoja-astian? Tilaa tällöin lisäksi myös Turvaroskis tai Turvaroskis Plus -palvelu",
                inputLabel: "Vaihda rullakko 240L astiaksi",
                summaryInputLabel: "Vaihdettu rullakko 240L astiaksi",
            },
        },
        latestOrderOn: "Viimeisin tilaus vastaanotettu: {0}",
        marketingPermission: "Kuusakoski Oy saa lähettää minulle markkinointiviestejä.",
        noUnitsSelectedError: "Tilauksella ei ole astioita. Valitse vähintään yksi astia.",
        orderRecyclingContainer: "Tilaa kierrätysastia",
        orderRecyclingContainerRetrieval: "Tilaa kierrätysastian poisnouto",
        privacypolicy: "<a href='https://www.kuusakoski.com/fi/finland/yritys/vastuullisuus/tietosuoja-kuusakoskella/'>Kuusakoski Recycling tietosuojapolitiikka</a>",
        products: "Tuotteet",
        productLabel: {
            rullakko: "Rullakko/turvarullakko",
            tietosuojaAstia: "Turvaroskis/turvaroskis plus",
        },
        readMoreAboutService: "Lue lisää palvelusta",
        retrieveBinAmount: "Noudettavien astioiden lukumäärät",
        retrieveInformation: "Haluatko noudettavien astioiden tilalle uusia? Täytä ensin noutolomake loppuun, seuraavalla sivulla pääset tilaamaan uusia astioita",
        thanksForOrdering: "Kiitos tilauksesta",
        extraInformation: "Lisätiedot",
        unhandledError: "Virhe tilauksen käsittelyssä. Ota yhteyttä asiakaspalveluun 0800 30880, asiakaspalvelu@kuusakoski.com",
        requiredFieldsMissing: "Pakollisia tietoja puuttuu",
        selectSingleProductLabel: "Haluan yhteydenoton ja tarjouksen",
        serviceDescription: "<p>Valitse alta sopivin palvelu. Tarvitsetko apua palvelun valinnassa? Tutustu usein kysyttyihin kysymyksiin tai lähetä sähköpostia: <a href=\"mailto:turvaroskis@kuusakoski.com\">turvaroskis@kuusakoski.com</a> - vastaamme nopeasti!</p><br><p>Palvelun ilmoitettu hinta sisältää yhdelle keräysastialle kaiken tarvittavan: Astian toimituksen ja astian vapaan pitoajan, astian poisviennin sekä materiaalin käsittelyn (+ tuhoamistodistuksen, mikäli kuuluu valittuun palveluun). Astiavuokria tai käsittelymaksuja ei jälkikäteen peritä, vaan ilmoitettu hinta sisältää kaikki kulut.</p><br><p>Tarvitsetko isomman astian? Valitse halutessasi 660-litrainen tietosuoja-astia lisähintaan 120 € per astia. Eli esimerkiksi Turvaroskis-palvelu 660 litran tietosuoja-astialla: 279 €</p>",
        serviceDescriptionPricing: "<p>Astia toimitetaan 5 arkipäivän sisällä tilauksesta. Astiatoimitukset tehdään arkisin klo 8-16 välisenä aikana.</p>",
        thanksForOrderingNewOrderText: "Haluatko noudettavien astioiden tilalle uudet?",
        thanksForOrderingNewOrder: "Tee uusi tilaus",
        thanksForOrderingTitle: "Kiitos tilauksesta!",
        thanksForOrderingDeliveryBody: "Tilauksesi toimitetaan 5 arkipäivän sisällä.",
        thanksForOrderingRetrievalBody: "Teemme noudon 5 arkipäivän sisällä.",
        thanksForOrderingContact: "Jos sinulla on kysyttävää tai korjattavaa tilaukseen liittyen, voit ottaa yhteyttä turvaroskis@kuusakoski.com",
        thanksForOrderingReturn: "Palaa palvelun etusivulle",
    },
    weeeOrder: {
        contact: {
            contact: "Tilaajan yhteystiedot",
            firstName: "Etunimi",
            lastName: "Sukunimi",
            email: "Sähköposti",
            phone: "Puhelin",
            businessId: "Y-tunnus",
            company: "Yritys"
        },
        extraInformation: "Lisätiedot",
        ovtBillingInformation: "Verkkolaskutustiedot",
        customerOrderNumber: "Viitetieto laskulle (ei pakollinen)",
        ovtNumber: "OVT-tunnus",
        ovtOperator: "Operaattori",
    },
    weeeProduct: {
        extraInformation: "Lisätiedot",
    },
    validationErrors: {
        invalidEmail: "Virheellinen sähköpostiosoite",
        invalidValue: "Virheellinen arvo",
        required: "Pakollinen kenttä",
    },
};
